(function PartnerModule() {

    $('input#centerPlace').on('focus', function() {
        $('input#centerPlace').val('');
    })

    var Pager = (function() {

        var api = {
            getCurrentIndex: function() {
                return currentIndex
            },
            getItemsPerPage: function() {
                return itemsPerPage
            },
            setPage: setPage,
            reset: reset
        }

        var currentIndex = 0;
        var itemsPerPage = 10;
        var itemsCount = 0;
        var pageCount = 0;
        var pageChanged;

        $(document).on('click', '.pagination li a', function(ev) {
            var index = $(ev.target).closest('[tabindex]').attr('tabindex');
            if (index == "prev") {
                decreasePage();
            } else if (index == "next") {
                increasePage();
            } else {
                setPage(+index);
            }

        });


        function reset(cnt, pageChangedCallback) {
            itemsCount = cnt;
            currentIndex = 0;
            pagesCount = Math.floor(itemsCount / itemsPerPage) + (itemsCount % itemsPerPage > 0 ? 1 : 0);
            pageChanged = pageChangedCallback;
            createPager();
        }

        function decreasePage() {
            if (currentIndex > 0) {
                currentIndex--;
                setPager();
            }
        }

        function increasePage() {
            if (currentIndex < pagesCount - 1) {
                currentIndex++;
                setPager();
            }
        }

        function setPage(pageIdx) {
            if (pageIdx > -1 && pageIdx < pagesCount) {
                currentIndex = pageIdx;
                setPager();
            }
        }

        function setPager() {
            var pages = $('ul.pagination li:not(".fixed")');
            pages.removeClass('active');
            $('ul.pagination li.fixed').removeClass('disabled');
            $('ul.pagination li a[tabindex=' + currentIndex + ']').parent().addClass('active');
            if (currentIndex == pages.length - 1)
                $('ul.pagination li:last-of-type').addClass('disabled');
            if (currentIndex == 0)
                $('ul.pagination li:first-of-type').addClass('disabled');
            if (pageChanged)
                pageChanged(currentIndex, itemsPerPage);

            if (currentIndex == pages.length - 1) {
                $('.counter').html((((currentIndex) * itemsPerPage) + 1) + '-' + itemsCount + ' ' + translations.partners_count_of + ' ' + itemsCount + ' ' + translations.partners_count_partners);
            } else {
                //remove 0 partners title
                $('.counter').html((((currentIndex) * itemsPerPage) + 1) + '-' + ((currentIndex + 1) * itemsPerPage) + ' ' + translations.partners_count_of + ' ' + itemsCount + ' ' + translations.partners_count_partners);
                //$('.counter').html(' ');
            }

            $('ul.pagination li:not(.fixed):not(.active)').addClass('hidden');
            $('ul.pagination li a[tabindex=' + 0 + ']').parent().removeClass('hidden');
            $('ul.pagination li a[tabindex=' + (currentIndex - 2) + ']').parent().removeClass('hidden');
            $('ul.pagination li a[tabindex=' + (currentIndex - 1) + ']').parent().removeClass('hidden');
            $('ul.pagination li a[tabindex=' + (currentIndex + 1) + ']').parent().removeClass('hidden');
            $('ul.pagination li a[tabindex=' + (currentIndex + 2) + ']').parent().removeClass('hidden');
            $('ul.pagination li a[tabindex=' + (pages.length - 1) + ']').parent().removeClass('hidden');

            $('ul.pagination li').removeClass('prevDots');
            $('ul.pagination li').removeClass('nextDots');

            if (currentIndex > 3) {
                $('ul.pagination li a[tabindex=' + (currentIndex - 2) + ']').parent().addClass('prevDots');
            } else {
                $('ul.pagination li a[tabindex=' + (currentIndex - 2) + ']').parent().removeClass('prevDots');
            }

            if (currentIndex < (pages.length - 4)) {
                $('ul.pagination li a[tabindex=' + (currentIndex + 2) + ']').parent().addClass('nextDots');
            } else {
                $('ul.pagination li a[tabindex=' + (currentIndex + 2) + ']').parent().removeClass('nextDots');
            }
        }

        function createPager() {
            $('ul.pagination li:not(".fixed")').remove();
            for (var i = pagesCount - 1; i > -1; i--) {
                $('<li class="page-item dynamic"><a class="page-link" tabindex="' + i + '">' + (i + 1) + '</a></li>').insertAfter('ul.pagination li:first-of-type');
            }
            setPager();
            pageChanged(currentIndex, itemsPerPage);
        }

        return api;

    })();

    var GoogleMap = (function() {

        var api = {
            init: init,
            get: function() {
                return map
            },
            getBounds: function() {
                return bounds
            }
        }

        var map;
        var center;
        var centerChanged;
        var defaultCenter = { lat: 47.49801, lng: 19.03991 };
        var geocoder;
        var bounds;

        function init(centerChangedCallback) {

            centerChanged = centerChangedCallback;

            geocoder = new google.maps.Geocoder;
            map = new google.maps.Map(document.getElementById('map'), {
                zoom: 8,
                center: defaultCenter,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });
            centerChanged(defaultCenter);

            //create bounds
            bounds = new google.maps.LatLngBounds();


            var options = {}
            if (window.bauminatorData && window.bauminatorData.mapData && window.bauminatorData.mapData.countryCode && window.bauminatorData.mapData.countryCode != 'com') {
                options.componentRestrictions = { country: window.bauminatorData.mapData.countryCode };
                if (countryMapCenterPosition && countryMapCenterPosition.lat !== null && countryMapCenterPosition.lng !== null) {
                    map.setCenter(countryMapCenterPosition);
                    if (centerChanged) {
                        centerChanged(countryMapCenterPosition);
                    }
                } else {
                    geocoder.geocode({ address: countries.getCountry(window.bauminatorData.mapData.countryCode) },
                        function(results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                map.setCenter(results[0].geometry.location);
                                center = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                                if (centerChanged)
                                    centerChanged(center);
                            }
                        }
                    );
                }

            }
            
            var $centerPlace = $('input#centerPlace');
            var autocomplete = new google.maps.places.Autocomplete($centerPlace.get(0), options);

            /* autocomplete order hack begin */
            
            var observer = new MutationObserver(function(mutations) {
                observer.disconnect();
                var $list = $('.pac-container.pac-logo');
                $list.children().sort(function(a, b){
                    var aText = $(a).text();
                    var bText = $(b).text();
                    return aText.localeCompare(bText);
                }).appendTo($list);
            });
            var cfg = { attributes: false, childList: true, characterData: false }

            $centerPlace.on('input', function() {
                var $list = $('.pac-container.pac-logo');
                observer.observe($list[0], cfg);
            })

            /* autocomplete order hack end */


            autocomplete.addListener('place_changed', function() {
                $(".dropdown-item").filter("[data-distance=20]").trigger("click")
                var place = autocomplete.getPlace();
                if (place.geometry) {
                    map.setCenter(place.geometry.location);
                    center = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
                    if (centerChanged)
                        centerChanged(center);
                    map.setZoom(8);
                }
            })
            centerCurrentPosition();
        }


        $(document).on('click', '#my-position', centerCurrentPosition);


        //TODO: add back this function
        //when the origin gets safe

        function centerCurrentPosition() {
            $('input#centerPlace').val('');
            navigator.geolocation.getCurrentPosition(function(loc) {
                center = { lat: loc.coords.latitude, lng: loc.coords.longitude };
                map.setCenter(center);
                centerChanged(center);

                geocoder.geocode({ 'location': new google.maps.LatLng(center) }, function(results, status) {
                    if (status === 'OK') {
                        $('input#centerPlace').val(results[0].formatted_address);
                    }
                })
            })
        }

        // function centerCurrentPosition() {
        //     $('input#centerPlace').val('');

        //     center = defaultCenter;
        //     map.setCenter(center);
        //     centerChanged(center);
        //     geocoder.geocode({ 'location': new google.maps.LatLng(center) }, function (results, status) {
        //         if (status === 'OK') {
        //             $('input#centerPlace').val(results[0].formatted_address);
        //         }
        //     })

        // }

        return api;
    })()

    var InfoWindow = (function() {

        var api = {
            createContent: createContent,
            popup: popup,
            close: close,
            detailsClickCallback: detailsClickCallback
        }

        var infoWindow;
        var callback;

        $(document).on('click', '.info-window .details', function(ev) {
            if (callback)
                callback($(ev.target).attr('data-id'));
        });

        function detailsClickCallback(cb) {
            callback = cb;
        }

        function createContent(partner) {
            var htmlPartnerInfo = '';

            htmlPartnerInfo += '<div class="info-window">';
            htmlPartnerInfo += '<div class="main-info"><h4>' + partner.name + '</h4><p class="bodytext">' + partner.address + '<br>' + partner.zip + ' ' + partner.city + '</p></div>';
            if (window.bauminatorData && typeof window.bauminatorData.showPartners != 'undefined' && window.bauminatorData.showPartners == true) {
                htmlPartnerInfo += '<div class="extended-info-buttons"><span class="details" data-id="' + partner.id + '"><span class="mdi mdi-plus-circle-outline"></span>' + translations.partners_details + '</span></div>';
            }

            htmlPartnerInfo += '</div>';

            return htmlPartnerInfo;
        }

        function close() {
            if (infoWindow)
                infoWindow.close();
        }

        function popup(marker) {
            close();
            infoWindow = new google.maps.InfoWindow({ content: marker.infoContent });
            infoWindow.open(map, marker);
        }

        return api;

    })();


    var Marker = (function() {
        var api = {
            create: create,
            show: show,
            hide: hide
        };

        var defaultColor = 'silver';

        function getColor(partnerTypes, partner) {
            var partnerColors = partnerTypes.filter(function(t) {
                return partner.partner_types.indexOf(t.id.toString()) > -1;
            });



            if (partnerColors.length) {
                return partnerColors.map(function(col) { return col.marker_color_hex });
                //color = partnerColor[0].marker_color_hex;
            }
            return [defaultColor];
        }

        function create(partner, partnerTypes, imageFn, map, allCountries) {
            var marker = new google.maps.Marker({
                map: map,
                position: { lat: parseFloat(partner.latitude), lng: parseFloat(partner.longitude) },
                icon: {
                    scale: 1,
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 44),
                    url: imageFn(allCountries ? ['#df0a25'] : getColor(partnerTypes, partner))
                },
                id: partner.id
            })
            return marker;
        }

        function hide(partner) {
            partner.marker.setVisible(false);
        }

        function show(partner) {
            partner.marker.setVisible(true);
        }

        return api;
    })();

    var Filters = (function() {
        var api = {
            get: get,
            initUi: initUi,
            reset: reset
        }


        function initUi(types, imageFn, filterChangeCallback, allCountries) {
            if (!allCountries) {
                types.forEach(function(t) {
                    $('.filter-container input[data-filter="' + t.id + '"]').parent().find('.custom-control-description-icon').css({ 'background-image': 'url("' + imageFn([t.marker_color_hex]) + '")' });
                });
                $('.partner-selector').fadeIn();
            }
            reset();
            $(document).on('change', '.filter-container input', function() {
                filterChangeCallback(get());
            });
            $(document).on('click', '[data-distance]', function() {
                filterChangeCallback(get());
            });
            $(document).on('click', '.filter-container a#reset', function() {
                reset(filterChangeCallback)
            });
        }

        function reset(filterChangeCallback) {
            //$('.filter-container input').prop('checked', true);
            $('.filter-container').find('input').each(function(i, el) {
                if ($(el).data('defaultselected') == 1) {
                    $(el).prop('checked', true);
                } else {
                    $(el).prop('checked', false);
                }
            });
            $('#distance-selection').text($('[data-distance=Infinity]').text());
            if (filterChangeCallback)
                filterChangeCallback(get());
        }

        function get() {
            var types = [];
            $('.filter-container').find('input').each(function(i, el) {
                if ($(el).prop('checked'))
                    types.push(+$(el).attr('data-filter'));
            });
            var r = $('#distance-selection').text();
            var radius = $('[data-distance]:contains(' + r + ')').attr('data-distance');
            return {
                types: types,
                radius: radius
            };
        }

        return api;

    })();

    var PartnerTypes = (function() {
        var api = {
            get: get
        }

        var types;

        function get() {
            if (!types) {
                types = window.bauminatorData.mapData.partnerTypes.map(function(t) {
                    return {
                        id: t.id,
                        name: t.name,
                        marker_color_hex: t.marker_color_hex
                    }
                });
            }
            return types;
        }

        return api;
    })();

    var PartnerUi = (function() {

        var api = {
            createList: createList,
            mapClickCallback: mapClickCallback
        }

        var callback;

        $(document).on('click', '.partner .details', function() {
            if ($(this).closest('.partner').hasClass('opened')) {
                $('.partner').removeClass('opened');
                $('.partner').find('.details span').removeClass('mdi-minus-circle-outline').addClass('mdi-plus-circle-outline');
                $('.extended-info').slideUp();
            } else {
                $('.partner').removeClass('opened');
                $('.partner').find('.details span').removeClass('mdi-minus-circle-outline').addClass('mdi-plus-circle-outline');
                $('.extended-info').slideUp();
                $(this).closest('.partner').addClass('opened');
                $(this).closest('.partner').find('.details span').removeClass('mdi-plus-circle-outline').addClass('mdi-minus-circle-outline');
                $(this).closest('.partner').find('.extended-info').slideDown();
            }
        });


        $(document).on('click', '.partners .map', function(ev) {
            var id = $(ev.target).attr('data-id');
            //var partner = partners.filter(function (p) { return p.id == id });
            //if (partner.length > 0) {
            callback(id);
            //}
        });

        function mapClickCallback(cb) {
            callback = cb;
        }

        function createHtml(partner) {
            var htmlPartner = '';

            htmlPartner = '<div class="col-lg-6 partner" data-type-id="' + partner.partner_type_id + '"><div class="inner relative">'

            if (partner.partner_type_id == 2) {
                htmlPartner += '<div class="premium">' + translations.partners_premium_partner + '</div>'
            }

            htmlPartner += '<div class="main-info"><h4>' + partner.name + '</h4><p class="bodytext">' + partner.address + '<br>' + partner.zip + ' ' + partner.city + '</p></div><div class="extended-info">'

            if (partner.phone != null && partner.phone != "") {
                htmlPartner += '<p class="bodytext m-0 d-flex justify-content-start"><span class="d-inline-block mr-1">' + translations.partners_tel + '</span><span class="d-inline-block">' + partner.phone + '</span></p>'
            }

            if (partner.fax != null && partner.fax != "") {
                htmlPartner += '<p class="bodytext m-0">' + translations.partners_fax + ' ' + partner.fax + '</p>'
            }

            if (partner.email != null && partner.web != "") {
                htmlPartner += '<p class="bodytext m-0"><a href="mailto:' + partner.email + '">' + partner.email + '</a></p>'
            }

            if (partner.web != null && partner.web != "") {
                if (partner.web.indexOf('https') >= 0) {
                    var str = partner.web.split('https://')[1];
                    var last = str.substr(str.length - 1);

                    if (last == '/') {
                        htmlPartner += '<p class="bodytext m-0"><a href="' + partner.web + '" target="_blank">' + str.split(last)[0] + '</a></p>'
                    } else {
                        htmlPartner += '<p class="bodytext m-0"><a href="' + partner.web + '" target="_blank">' + str + '</a></p>'
                    }
                } else if (partner.web.indexOf('http') >= 0) {
                    var str = partner.web.split('http://')[1];
                    var last = str.substr(str.length - 1);

                    if (last == '/') {
                        htmlPartner += '<p class="bodytext m-0"><a href="' + partner.web + '" target="_blank">' + str.split(last)[0] + '</a></p>'
                    } else {
                        htmlPartner += '<p class="bodytext m-0"><a href="' + partner.web + '" target="_blank">' + str + '</a></p>'
                    }
                } else {
                    htmlPartner += '<p class="bodytext m-0"><a href="' + partner.web + '" target="_blank">' + partner.web + '</a></p>'
                }
            }

            htmlPartner += '</div><div class="extended-info-buttons d-flex justify-content-start"><span class="map" data-id="' + partner.id + '"><span class="mdi mdi-map-marker"></span>' + translations.partners_map + '</span><span class="details '

            if (partner.phone == "" && partner.fax == "" && partner.email == "" && partner.web == null) {
                htmlPartner += 'disabled d-none '
            }

            htmlPartner += 'ml-auto" data-id="' + partner.id + '"><span class="mdi mdi-plus-circle-outline"></span>' + translations.partners_details + '</span></div></div></div>'

            return htmlPartner;
        }

        function createList(partners) {
            $('.partners').html('');
            if (window.bauminatorData && typeof window.bauminatorData.showPartners != 'undefined' && window.bauminatorData.showPartners == false) {
                return;
            }
            if (!partners || !partners.length) return;
            partners.forEach(function(partner) {
                $('.partners').append(createHtml(partner));
            });
        }

        return api;
    })()

    var Partners = (function() {

        var api = {
            setFilter: setFilter,
            setCenter: setCenter,
            get: get,
            getFiltered: getFiltered,
            filteredCnt: filteredCnt,
            sliceAndFilter: sliceAndFilter,
            ajaxGet: ajaxGet,
            getPartnerPage: getPartnerPage,
            isInfinite: isInfinite
        }

        var partnerFilter;
        var center;
        var partners = [];

        function setFilter(filter) { //selected types
            partnerFilter = filter;
        }

        function setCenter(c) {
            center = c;
        }

        function get() {
            return partners;
        }

        function isInfinite() {
            return partnerFilter.radius == 'Infinity';
        }


        filterByTypes = function(partnerTypes) {
            var i = 0;
            while (i < partnerTypes.length && partnerFilter.types.indexOf(+partnerTypes[i]) < 0)
                i++;
            return (i < partnerTypes.length);
        }


        function sortFromCenter() {
            partners.forEach(function(partner) {
                partner.fromCenter = calcCrow(partner.latitude, partner.longitude, center.lat, center.lng);
            })

            /*partners.sort(function(a, b) {
                return a.fromCenter - b.fromCenter;
            });*/

            partners.sort(function(a, b) {
                let lc = a.name.localeCompare(b.name)
                return lc === 0 ? a.city.localeCompare(b.city) : lc;
            });

        }

        function calcCrow(lat01, lon01, lat02, lon02)
        {
            let R = 6371; // km
            let dLat = (lat02-lat01)* Math.PI / 180;
            let dLon = (lon02-lon01)* Math.PI / 180;
            let lat1 = (lat01)* Math.PI / 180;
            let lat2 = (lat02)* Math.PI / 180;

            let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
        }

        function getFiltered(allCountries) {
            if (center && partnerFilter) {
                sortFromCenter();
                let filteredPartners = partners.filter(function(p) {
                    return (
                        (allCountries || filterByTypes(p.partner_types)) &&
                        (p.fromCenter <= parseFloat(partnerFilter.radius))
                    )
                });
                return filteredPartners
            } else if (partners.length > 0) {
                return partners;
            } else {
                return [];
            }
        }


        function filteredCnt(allCountries) {
            return getFiltered(allCountries).length;
        }

        function sliceAndFilter(from, cnt, allCountries) {
            return getFiltered(allCountries).slice(from * cnt, (from + 1) * cnt);
        }

        function getPartnerPage(id, itemsPerPage, allCountries) {
            var filtered = getFiltered(allCountries);
            var f = filtered.filter(function(p) {
                return p.id == id;
            });
            if (f.length) {
                return Math.floor(filtered.indexOf(f[0]) / itemsPerPage);
            }
            return -1;
        }


        function ajaxGet(allCountries, callback) {
            $.ajax({

                url: allCountries ? ' /ajaxGetPartnersToBauminator?allCountry=true' : '/ajaxGetPartnersToBauminator'
            }).done(function(result) {
                partners = result.filter(p => p.latitude && p.longitude)
                callback(partners);
            });
        }

        return api;
    })();


    var MarkerImage = (function() {
        var api = {
            create: create
        };

        function create(colors) {
            var svg = 'data:image/svg+xml;charset=utf-8,';
            var colorCnt = colors.length;
            switch (colorCnt) {
                case 1:
                    return svg + encodeURIComponent(marker.replace('~color1~', colors[0]));
                case 2:
                    return svg + encodeURIComponent(marker2.replace('~color1~', colors[0]).replace('~color2~', colors[1]));
                case 3:
                    return svg + encodeURIComponent(marker3.replace('~color1~', colors[0]).replace('~color2~', colors[1]).replace('~color3~', colors[2]));
                    //no more than 4 colors
                default:
                    return svg + encodeURIComponent(marker4.replace('~color1~', colors[0]).replace('~color2~', colors[1]).replace('~color3~', colors[2]).replace('~color4~', colors[3]));

            }
        }


        var marker = '<svg xmlns="http://www.w3.org/2000/svg" width="34px" height="44px" viewBox="0 0 34 44"><style>.color-1 {fill: ~color1~ }</style><title>marker</title><path class="color-1" d="M17,0A17.1,17.1,0,0,0,0,17.2C0,28.8,17,44,17,44S34,28.8,34,17.2A17.1,17.1,0,0,0,17,0Zm0,28.9A11.7,11.7,0,1,1,28.6,17.2,11.7,11.7,0,0,1,17,28.9Z" /><circle cx="17" cy="17" r="12" style="fill:#fff"/><path d="M19.4,11.2a2.3,2.3,0,0,1,.2.8v2.4H18.2V12.2a1.1,1.1,0,0,0-.7-0.8,0.9,0.9,0,0,0-.9.2,0.9,0.9,0,0,0-.3.8,0.9,0.9,0,0,0,.7.7,1.1,1.1,0,0,0,.8-0.2v1.6H17.5a2.3,2.3,0,0,1-2.3-1.2,2.3,2.3,0,0,1,.1-2.4,2.4,2.4,0,0,1,2.3-.9,2.3,2.3,0,0,1,1.7,1.3"/><path d="M12.9,9.9s0,0,0,0h0.3a2,2,0,0,1,1.3,1.6,2.1,2.1,0,0,1-.4,1.6l0.2,0.4a2.3,2.3,0,0,1,0,1.8,2.1,2.1,0,0,1-1.5,1.2H10V15.2h2.6a1.1,1.1,0,0,0,.5-0.4,0.6,0.6,0,0,0,0-.4,0.7,0.7,0,0,0-.5-0.4H10V12.5h2.8a0.6,0.6,0,0,0,.4-0.4,0.6,0.6,0,0,0-.1-0.5l-0.4-.3H10V9.9h2.9Z"/><path d="M21.4,9.9v2.8a0.6,0.6,0,0,0,.6.3,0.7,0.7,0,0,0,.7-0.3V9.9H24v2.9a2,2,0,0,1-1.5,1.6,2.1,2.1,0,0,1-2.2-.8,1.9,1.9,0,0,1-.3-1V9.9h1.4"/><path d="M24,14.9c0,0.6,0,0,0,0v8.9H15V15h9Z" style="fill:#e1001a"/><rect x="10" y="17.4" width="4.4" height="1.39"/><path d="M14.4,23.9H13V22.3H10V20.9h3c0-.5,0-1.6,0-1.6h1.4v4.6Z"/><rect x="14.9" y="14.8" width="9.1" height="9.1" style="fill:#e1001a"/></svg>'
        var marker2 = '<svg xmlns="http://www.w3.org/2000/svg" width="34px" height="44px" viewBox="0 0 34 44"><style>.color-1 {fill: ~color1~ } .color-2 {fill: ~color2~ }</style><title>marker_2-es</title><path d="M17,28.9h0A11.74,11.74,0,0,1,17,5.43h0V0h0A17.09,17.09,0,0,0,0,17.17C0,28.8,17,44,17,44l0,0Z" class="color-1"/><path d="M17,28.9h0A11.74,11.74,0,0,0,17,5.43h0V0h0A17.09,17.09,0,0,1,34,17.17C34,28.8,17,44,17,44l0,0Z" class="color-2"/><circle cx="17" cy="17" r="12" style="fill:#fff"/><path d="M19.41,11.23a2.17,2.17,0,0,1,.21.85v2.39h-1.4V12.19a1.09,1.09,0,0,0-.71-.83,1,1,0,0,0-.86.21.85.85,0,0,0-.27.84.88.88,0,0,0,.68.66,1.17,1.17,0,0,0,.81-.18v1.58a1.12,1.12,0,0,1-.41,0,2.3,2.3,0,0,1-2.13-3.62A2.39,2.39,0,0,1,17.67,10a2.31,2.31,0,0,1,1.74,1.28"/><path d="M12.94,9.92s0,0,0,0,.24.05.34.08A2,2,0,0,1,14.6,11.6a2.08,2.08,0,0,1-.42,1.61c.06.13.17.25.23.38a2.28,2.28,0,0,1,0,1.76,2.05,2.05,0,0,1-1.55,1.18l-2.89,0v-1.4h2.62c.16,0,.4-.29.49-.41a.64.64,0,0,0,0-.43.71.71,0,0,0-.51-.39H10v-1.4h2.8a.59.59,0,0,0,.35-.45.64.64,0,0,0-.11-.51.67.67,0,0,0-.42-.26H10V9.92h2.93Z"/><path d="M21.38,9.92v2.8c0,.17.32.31.55.33s.67-.16.67-.33V9.92H24v2.93a2.06,2.06,0,0,1-1.53,1.59,2.1,2.1,0,0,1-2.16-.82,1.85,1.85,0,0,1-.33-1V9.92h1.4"/><path d="M24,14.89c0,.63,0,0,0,0v8.93H15V14.89Z" style="fill:#e1001a"/><rect x="10.01" y="17.45" width="4.37" height="1.39"/><path d="M14.37,23.92H13V22.34H10v-1.4h3c0-.49,0-1.57,0-1.57h1.4Z"/><rect x="14.9" y="14.82" width="9.1" height="9.1" style="fill:#e1001a"/></svg>'
        var marker3 = '<svg xmlns="http://www.w3.org/2000/svg" width="34px" height="44px" viewBox="0 0 34 44"><style>.color-1 {fill: ~color1~ } .color-2 {fill: ~color2~ } .color-3 {fill: ~color3~ }</style><title>marker_3-as</title><path d="M11.33,27.4a11.78,11.78,0,0,1,0-20.47V1A17.15,17.15,0,0,0,0,17.17C0,24.3,6.39,32.76,11.33,38.25Z" class="color-1"/><path d="M22.67,6.93V1A16.57,16.57,0,0,0,11.33,1V6.93a11.47,11.47,0,0,1,11.34,0Z" class="color-2"/><path d="M22.67,27.41a11.5,11.5,0,0,1-11.34,0V38.25C14.45,41.72,17,44,17,44s2.55-2.28,5.67-5.74Z" class="color-2"/><path d="M22.67,6.93a11.79,11.79,0,0,1,0,20.48V38.26C27.61,32.77,34,24.3,34,17.17A17.16,17.16,0,0,0,22.67,1Z" class="color-3"/><circle cx="17" cy="17" r="12" style="fill:#fff"/><path d="M19.41,11.23a2.17,2.17,0,0,1,.21.85v2.39h-1.4V12.19a1.09,1.09,0,0,0-.71-.83,1,1,0,0,0-.86.21.85.85,0,0,0-.27.84.88.88,0,0,0,.68.66,1.17,1.17,0,0,0,.81-.18v1.58a1.12,1.12,0,0,1-.41,0,2.3,2.3,0,0,1-2.13-3.62A2.39,2.39,0,0,1,17.67,10a2.31,2.31,0,0,1,1.74,1.28"/><path d="M12.94,9.92s0,0,0,0,.24.05.34.08A2,2,0,0,1,14.6,11.6a2.08,2.08,0,0,1-.42,1.61c.06.13.17.25.23.38a2.28,2.28,0,0,1,0,1.76,2.05,2.05,0,0,1-1.55,1.18l-2.89,0v-1.4h2.62c.16,0,.4-.29.49-.41a.64.64,0,0,0,0-.43.71.71,0,0,0-.51-.39H10v-1.4h2.8a.59.59,0,0,0,.35-.45.64.64,0,0,0-.11-.51.67.67,0,0,0-.42-.26H10V9.92h2.93Z"/><path d="M21.38,9.92v2.8c0,.17.32.31.55.33s.67-.16.67-.33V9.92H24v2.93a2.06,2.06,0,0,1-1.53,1.59,2.1,2.1,0,0,1-2.16-.82,1.85,1.85,0,0,1-.33-1V9.92h1.4"/><path d="M24,14.89c0,.63,0,0,0,0v8.93H15V14.89Z" style="fill:#e1001a"/><rect x="10.01" y="17.45" width="4.37" height="1.39"/><path d="M14.37,23.92H13V22.34H10v-1.4h3c0-.49,0-1.57,0-1.57h1.4Z"/><rect x="14.9" y="14.82" width="9.1" height="9.1" style="fill:#e1001a"/></svg>'
        var marker4 = '<svg xmlns="http://www.w3.org/2000/svg" width="34px" height="44px" viewBox="0 0 34 44"><style>.color-1 {fill: ~color1~ } .color-2 {fill: ~color2~ } .color-3 {fill: ~color3~ } .color-4 {fill: ~color4~ }</style><title>marker-4es</title><path d="M8.51,25.16a11.78,11.78,0,0,1,0-16V2.31A17.18,17.18,0,0,0,0,17.17C0,23,4.26,29.7,8.51,35Z"  class="color-1"/><path d="M8.49,25.14v9.79A86.25,86.25,0,0,0,17,44l0,0V28.9h0A11.51,11.51,0,0,1,8.49,25.14Z"  class="color-2"/><path d="M17,0A16.75,16.75,0,0,0,8.49,2.32V9.19A11.51,11.51,0,0,1,17,5.43h0V0Z"  class="color-2"/><path d="M25.58,25.1A11.52,11.52,0,0,1,17,28.9h0V44l0,0a86.38,86.38,0,0,0,8.54-9.11Z"  class="color-3"/><path d="M25.58,9.23V2.34A16.75,16.75,0,0,0,17,0h0V5.43h0A11.52,11.52,0,0,1,25.58,9.23Z" class="color-3"/><path d="M25.58,9.23a11.76,11.76,0,0,1,0,15.87v9.79C29.82,29.64,34,23,34,17.17A17.18,17.18,0,0,0,25.58,2.34Z"  class="color-4"/><circle cx="17" cy="17" r="12" style="fill:#fff"/><path d="M19.41,11.23a2.17,2.17,0,0,1,.21.85v2.39h-1.4V12.19a1.09,1.09,0,0,0-.71-.83,1,1,0,0,0-.86.21.85.85,0,0,0-.27.84.88.88,0,0,0,.68.66,1.17,1.17,0,0,0,.81-.18v1.58a1.12,1.12,0,0,1-.41,0,2.3,2.3,0,0,1-2.13-3.62A2.39,2.39,0,0,1,17.67,10a2.31,2.31,0,0,1,1.74,1.28"/><path d="M12.94,9.92s0,0,0,0,.24.05.34.08A2,2,0,0,1,14.6,11.6a2.08,2.08,0,0,1-.42,1.61c.06.13.17.25.23.38a2.28,2.28,0,0,1,0,1.76,2.05,2.05,0,0,1-1.55,1.18l-2.89,0v-1.4h2.62c.16,0,.4-.29.49-.41a.64.64,0,0,0,0-.43.71.71,0,0,0-.51-.39H10v-1.4h2.8a.59.59,0,0,0,.35-.45.64.64,0,0,0-.11-.51.67.67,0,0,0-.42-.26H10V9.92h2.93Z"/><path d="M21.38,9.92v2.8c0,.17.32.31.55.33s.67-.16.67-.33V9.92H24v2.93a2.06,2.06,0,0,1-1.53,1.59,2.1,2.1,0,0,1-2.16-.82,1.85,1.85,0,0,1-.33-1V9.92h1.4"/><path d="M24,14.89c0,.63,0,0,0,0v8.93H15V14.89Z" style="fill:#e1001a"/><rect x="10.01" y="17.45" width="4.37" height="1.39"/><path d="M14.37,23.92H13V22.34H10v-1.4h3c0-.49,0-1.57,0-1.57h1.4Z"/><rect x="14.9" y="14.82" width="9.1" height="9.1" style="fill:#e1001a"/></svg>'
        return api;

    })()


    var PartnerHandler = (function() {

        var allCountries = window.bauminatorData && window.bauminatorData.mapData && window.bauminatorData.mapData.countryCode && window.bauminatorData.mapData.countryCode == 'com';
        var markerCluster;


        function initMarkers() {

            if (allCountries)
                markerCluster = new MarkerClusterer(map, [], { imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m' });
            // markerCluster.setGridSize(300);
            Partners.get().forEach(function(partner) {
                partner.marker = Marker.create(partner, PartnerTypes.get(), MarkerImage.create, GoogleMap.get(), allCountries);
                partner.marker.infoContent = InfoWindow.createContent(partner);
                partner.marker.addListener('click', function() {
                    InfoWindow.popup(partner.marker)
                });
                if (allCountries)
                    markerCluster.addMarker(partner.marker);
                pushBounds(partner.latitude, partner.longitude);
            });


            // Partners.get().slice(500, 1000).forEach(function(partner) {
            //     partner.marker = Marker.create(partner, PartnerTypes.get(), MarkerImage.create, GoogleMap.get(), allCountries);
            //     partner.marker.infoContent = InfoWindow.createContent(partner);
            //     partner.marker.addListener('click', function() {
            //         InfoWindow.popup(partner.marker)
            //     });
            //     pushBounds(partner.latitude, partner.longitude);
            // });
            if (!allCountries)
                setBoundsCenter(2000);
            else
                setTimeout(function() {
                    GoogleMap.get().setZoom(3);
                }, 3000)

        }


        function pushBounds(latitude, longitude) {
            GoogleMap.getBounds().extend(new google.maps.LatLng(latitude, longitude));
        }

        function setBoundsCenter(timeout) {
            map = GoogleMap.get();

            setTimeout(function() {

                map.fitBounds(GoogleMap.getBounds());

            }, timeout);

            /*setTimeout(function() {
                console.log('call-resize');
                google.maps.event.trigger(map, 'resize');
            }, 1000);*/
        }

        function showPartners(currentPageIndex, itemsPerPage) {


            PartnerUi.createList(Partners.sliceAndFilter(currentPageIndex, itemsPerPage, allCountries));
        }

        function showMarkers(allCountries) {
            InfoWindow.close();
            if (allCountries && markerCluster)
                markerCluster.removeMarkers(markerCluster.getMarkers());
            Partners.get().forEach(function(p) {
                Marker.hide(p);

            });
            Partners.getFiltered(allCountries).forEach(function(p) {
                if (allCountries && markerCluster)
                    markerCluster.addMarker(p.marker);
                Marker.show(p);
            });

            map = GoogleMap.get();

            map.setZoom(allCountries && Partners.isInfinite() ? 3 : 9);


        }

        function filterChange(filter) {
            Partners.setFilter(filter);
            Pager.reset(Partners.filteredCnt(allCountries), showPartners);
            showMarkers(allCountries, false);

        }

        function centerChange(center) {
            Partners.setCenter(center);
            Pager.reset(Partners.filteredCnt(allCountries), showPartners);
            showMarkers(allCountries, true);
        }

        $(document).ready(function() {
            if (window.bauminatorData && window.bauminatorData.mapData && window.bauminatorData.mapData.partnerTypes) {
                Filters.initUi(PartnerTypes.get(), MarkerImage.create, filterChange, allCountries);
                InfoWindow.detailsClickCallback(scrollToPartner);
                PartnerUi.mapClickCallback(scrollToMap);
                Partners.setFilter(Filters.get());

                GoogleMap.init(centerChange);
                window.mymap = GoogleMap.get();
                Partners.ajaxGet(allCountries, function() {
                    initMarkers();
                    Pager.reset(Partners.filteredCnt(allCountries), showPartners);
                    Filters.reset(filterChange);
                    /*setTimeout(function() {
                        console.log('call-resize');
                        google.maps.event.trigger(GoogleMap.get(), 'resize');
                    }, 1000);*/
                })
            }
        });

        function reSizeMapsForViewAllMaker() {
            console.log('reSizeMapsForViewAllMaker');

            map.fitBounds(this.map.bounds);

            zoomChangeBoundsListener =
                google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                    if (this.getZoom()) { // or set a minimum
                        this.setZoom(16); // set zoom here
                    }
                });

            setTimeout(function() {
                google.maps.event.removeListener(zoomChangeBoundsListener)
            }, 2000);
        }


        function scroll2(pos, callback) {
            $("html, body").stop().animate({ scrollTop: pos }, 500, 'swing', callback);
        }

        function scrollToPartner(id) {
            var page = Partners.getPartnerPage(id, Pager.getItemsPerPage(), allCountries);
            Pager.setPage(page);
            var partnerDetails = $('.partners .details[data-id=' + id + ']');
            var parent = partnerDetails.closest('.partner');
            scroll2(parent.offset().top - 100, function() {
                if (!parent.hasClass('opened'))
                    partnerDetails.trigger('click');
            });
        }


        function scrollToMap(partnerid) {
            var partner = Partners.get().filter(function(p) {
                return p.id == partnerid
            });
            if (partner.length > 0) {
                scroll2($('.filter-container').offset().top - 100, function() {
                    GoogleMap.get().setCenter(new google.maps.LatLng(partner[0].latitude, partner[0].longitude));
                    map = GoogleMap.get();
                    map.setZoom(12);
                })
            }
        }


    })();

    var countries = (function() {
        var api = {
            getCountry: getCountry
        }
        var countries = {
            "AD": "ANDORRA",
            "AE": "UNITED ARAB EMIRATES",
            "AF": "AFGHANISTAN",
            "AG": "ANTIGUA AND BARBUDA",
            "AI": "ANGUILLA",
            "AL": "ALBANIA",
            "AM": "ARMENIA",
            "AN": "NETHERLANDS ANTILLES",
            "AO": "ANGOLA",
            "AQ": "ANTARCTICA",
            "AR": "ARGENTINA",
            "AS": "AMERICAN SAMOA",
            "AT": "AUSTRIA",
            "AU": "AUSTRALIA",
            "AW": "ARUBA",
            "AZ": "AZERBAIJAN",
            "BA": "BOSNIA AND HERZEGOVINA",
            "BB": "BARBADOS",
            "BD": "BANGLADESH",
            "BE": "BELGIUM",
            "BF": "BURKINA FASO",
            "BG": "BULGARIA",
            "BH": "BAHRAIN",
            "BI": "BURUNDI",
            "BJ": "BENIN",
            "BM": "BERMUDA",
            "BN": "BRUNEI DARUSSALAM",
            "BO": "BOLIVIA",
            "BR": "BRAZIL",
            "BS": "BAHAMAS",
            "BT": "BHUTAN",
            "BV": "BOUVET ISLAND",
            "BW": "BOTSWANA",
            "BY": "BELARUS",
            "BZ": "BELIZE",
            "CA": "CANADA",
            "CC": "COCOS (KEELING) ISLANDS",
            "CD": "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
            "CF": "CENTRAL AFRICAN REPUBLIC",
            "CG": "CONGO",
            "CH": "SWITZERLAND",
            "CI": "CÔTE D'IVOIRE",
            "CK": "COOK ISLANDS",
            "CL": "CHILE",
            "CM": "CAMEROON",
            "CN": "CHINA",
            "CO": "COLOMBIA",
            "CR": "COSTA RICA",
            "CU": "CUBA",
            "CV": "CAPE VERDE",
            "CX": "CHRISTMAS ISLAND",
            "CY": "CYPRUS",
            "CZ": "CZECH REPUBLIC",
            "DE": "GERMANY",
            "DJ": "DJIBOUTI",
            "DK": "DENMARK",
            "DM": "DOMINICA",
            "DO": "DOMINICAN REPUBLIC",
            "DZ": "ALGERIA",
            "EC": "ECUADOR",
            "EE": "ESTONIA",
            "EG": "EGYPT",
            "EH": "WESTERN SARARA",
            "ER": "ERITREA",
            "ES": "SPAIN",
            "ET": "ETHIOPIA",
            "FI": "FINLAND",
            "FJ": "FIJI",
            "FK": "FALKLAND ISLANDS (MALVINAS)",
            "FM": "MICRONESIA, FEDERATED STATES OF",
            "FO": "FAROE ISLANDS",
            "FR": "FRANCE",
            "GA": "GABON",
            "GB": "UNITED KINGDOM",
            "GD": "GRENADA",
            "GE": "GEORGIA",
            "GF": "FRENCH GUIANA",
            "GH": "GHANA",
            "GI": "GIBRALTAR",
            "GL": "GREENLAND",
            "GM": "GAMBIA",
            "GN": "GUINEA",
            "GP": "GUADELOUPE",
            "GQ": "EQUATORIAL GUINEA",
            "GR": "GREECE",
            "GS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
            "GT": "GUATEMALA",
            "GU": "GUAM",
            "GW": "GUINEA-BISSAU",
            "GY": "GUYANA",
            "HK": "HONG KONG",
            "HM": "HEARD ISLAND AND MCDONALD ISLANDS",
            "HN": "HONDURAS",
            "HR": "CROATIA",
            "HT": "HAITI",
            "HU": "HUNGARY",
            "ID": "INDONESIA",
            "IE": "IRELAND",
            "IL": "ISRAEL",
            "IN": "INDIA",
            "IO": "BRITISH INDIAN OCEAN TERRITORY",
            "IQ": "IRAQ",
            "IR": "IRAN, ISLAMIC REPUBLIC OF",
            "IS": "ICELAND",
            "IT": "ITALY",
            "JM": "JAMAICA",
            "JO": "JORDAN",
            "JP": "JAPAN",
            "KE": "KENYA",
            "KG": "KYRGYZSTAN",
            "KH": "CAMBODIA",
            "KI": "KIRIBATI",
            "KM": "COMOROS",
            "KN": "SAINT KITTS AND NEVIS",
            "KP": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
            "KR": "KOREA, REPUBLIC OF",
            "KW": "KUWAIT",
            "KY": "CAYMAN ISLANDS",
            "KZ": "KAZAKHSTAN",
            "LA": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
            "LB": "LEBANON",
            "LC": "SAINT LUCIA",
            "LI": "LIECHTENSTEIN",
            "LK": "SRI LANKA",
            "LR": "LIBERIA",
            "LS": "LESOTHO",
            "LT": "LITHUANIA",
            "LU": "LUXEMBOURG",
            "LV": "LATVIA",
            "LY": "LIBYAN ARAB JAMABIRIYA",
            "MA": "MOROCCO",
            "MC": "MONACO",
            "MD": "MOLDOVA, REPUBLIC OF",
            "MG": "MADAGASCAR",
            "MH": "MARSHALL ISLANDS",
            "MK": "MACEDONIA, THE FORMER YUGOSLAV REPU8LIC OF",
            "ML": "MALI",
            "MM": "MYANMAR",
            "MN": "MONGOLIA",
            "MO": "MACAU",
            "MP": "NORTHERN MARIANA ISLANDS",
            "MQ": "MARTINIQUE",
            "MR": "MAURITANIA",
            "MS": "MONTSERRAT",
            "MT": "MALTA",
            "MU": "MAURITIUS",
            "MV": "MALDIVES",
            "MW": "MALAWI",
            "MX": "MEXICO",
            "MY": "MALAYSIA",
            "MZ": "MOZAMBIQUE",
            "NA": "NAMIBIA",
            "NC": "NEW CALEDONIA",
            "NE": "NIGER",
            "NF": "NORFOLK ISLAND",
            "NG": "NIGERIA",
            "NI": "NICARAGUA",
            "NL": "NETHERLANDS",
            "NO": "NORWAY",
            "NP": "NEPAL",
            "NU": "NIUE",
            "NZ": "NEW ZEALAND",
            "OM": "OMAN",
            "PA": "PANAMA",
            "PE": "PERU",
            "PF": "FRENCH POLYNESIA",
            "PG": "PAPUA NEW GUINEA",
            "PH": "PHILIPPINES",
            "PK": "PAKISTAN",
            "PL": "POLAND",
            "PM": "SAINT PIERRE AND MIQUELON",
            "PN": "PITCAIRN",
            "PR": "PUERTO RICO",
            "PT": "PORTUGAL",
            "PW": "PALAU",
            "PY": "PARAGUAY",
            "QA": "QATAR",
            "RE": "RÉUNION",
            "RO": "ROMANIA",
            "RU": "RUSSIAN FEDERATION",
            "RW": "RWANDA",
            "SA": "SAUDI ARABIA",
            "SB": "SOLOMON ISLANDS",
            "SC": "SEYCHELLES",
            "SD": "SUDAN",
            "SE": "SWEDEN",
            "SG": "SINGAPORE",
            "SH": "SAINT HELENA",
            "SI": "SLOVENIA",
            "SJ": "SVALBARD AND JAN MAYEN",
            "SK": "SLOVAKIA",
            "SL": "SIERRA LEONE",
            "SM": "SAN MARINO",
            "SN": "SENEGAL",
            "SO": "SOMALIA",
            "SR": "SURINAME",
            "ST": "SAO TOME AND PRINCIPE",
            "SV": "EL SALVADOR",
            "SY": "SYRIAN ARAB REPUBLIC",
            "SZ": "SWAZILAND",
            "TC": "TURKS AND CAICOS ISLANDS",
            "TD": "CHAD",
            "TF": "FRENCH SOUTHERN TERRITORIES",
            "TG": "TOGO",
            "TH": "THAILAND",
            "TJ": "TAJIKISTAN",
            "TK": "TOKELAU",
            "TM": "TURKMENISTAN",
            "TN": "TUNISIA",
            "TO": "TONGA",
            "TP": "EAST TIMOR",
            "TR": "TURKEY",
            "TT": "TRINIDAD AND TOBAGO",
            "TV": "TUVALU",
            "TW": "TAIWAN, PROVINCE OF CHINA",
            "TZ": "TANZANIA, UNITED REPUBLIC OF",
            "UA": "UKRAINE",
            "UG": "UGANDA",
            "UM": "UNITED STATES MINOR OUTLYING ISLANDS",
            "US": "UNITED STATES",
            "UY": "URUGUAY",
            "UZ": "UZBEKISTAN",
            "VE": "VENEZUELA",
            "VG": "VIRGIN ISLANDS, BRITISH",
            "VI": "VIRGIN ISLANDS, U.S.",
            "VN": "VIET NAM",
            "VU": "VANUATU",
            "WF": "WALLIS AND FUTUNA",
            "WS": "SAMOA",
            "YE": "YEMEN",
            "YT": "MAYOTTE",
            "YU": "YUGOSLAVIA",
            "ZA": "SOUTH AFRICA",
            "ZM": "ZAMBIA",
            "ZW": "ZIMBABWE"
        };

        function getCountry(countryCode) {
            return countries[countryCode.toUpperCase()];
        }

        return api;

    })();

})();
